import { render, staticRenderFns } from "./TncModal.vue?vue&type=template&id=acfa4e68&"
import script from "./TncModal.vue?vue&type=script&lang=js&"
export * from "./TncModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports